<template>
	<div class="hello">
		<div class="jumbotron">
			<h1 class="display-4">Test Zone</h1>
			<p class="lead">
				A simple test area for new features.
			</p>
			<hr class="my-4" />
			<p>
				Button examples:
			</p>
			<p class="lead">
				<button type="button" class="btn btn-primary">Primary</button>
				<button type="button" class="ml-2 btn btn-secondary">Secondary</button>
			</p>
		</div>
		<div id="chart" v-if="ready">
        	<apexchart type="polarArea" :options="chartOptions" :series="series"></apexchart>
      </div>
	 
	</div>
	
</template>
<script>
export default {
	data() {
		return {
			ready: false,
			maxvalue: 10,
			series: [10,10,10,10,10,10],
			dataLabels: [
				'Knowledge',
				'Clinical Skill',
				'Opportunity',
				'Communication',
				'Results',
				'Motivation'
			],
			chartOptions: {}
		}
	},
	mounted() {
		this.getChartConfig();
		this.ready = true;
	},
	methods: {
		getChartConfig: function(){
			var self = this;
			this.chartOptions = {
				chart: {
					type: 'polarArea',
					events: {
						click: function(event, chartContext, config) {
							self.clickHandler(event, chartContext, config);
						}
					}
				},
				labels: this.dataLabels,
				yaxis: {
					max: this.maxvalue,
				},
				stroke: {
					colors: ['#fff']
				},
				fill: {
					opacity: 0.8
				},
				responsive: [{
					breakpoint: 2000,
					options: {
						chart: {
							width: 500
						},
						legend: {
							position: 'bottom'
						}
					}
				},{
					breakpoint: 480,
					options: {
						chart: {
							width: 200
						},
						legend: {
							position: 'bottom'
						}
					}
				}]
			}
		} ,
		clickHandler: function(event, chartContext, config) {
			// The last parameter config contains additional information like `seriesIndex` and `dataPointIndex` for cartesian charts
			console.log(event);
			console.log(chartContext);
			//this.series = [10, 12, 0, 5, 5, 1, 2, 4, 3];
			console.log(config);
			/*
			alert(event.clientX);
			alert(event.clientY);
			alert(chartContext.pie.centerX);
			alert(chartContext.pie.centerY);
			alert(chartContext.pie.donutSize);
			alert('Area:' + (Math.PI*Math.pow(chartContext.pie.donutSize, 2)));
			*/
			console.log(chartContext.el.parentElement.clientTop);
			//alert(chartContext.el.getBoundingClientRect().top);
			var relPoint = this.pointToRelPoint(
				{
					x: (chartContext.pie.centerX + chartContext.el.lastChild.getBoundingClientRect().left),
					y: (chartContext.pie.centerY + chartContext.el.lastChild.getBoundingClientRect().top)
				} ,
				{
					x: event.clientX,
					y: event.clientY
				}
			);
			//alert(JSON.stringify(relPoint));
			var clickangle = Math.atan2(relPoint.x, -relPoint.y) * 180 / Math.PI;
			if(clickangle < 0){
				clickangle += 360;
			}
			//var clickangleabs = clickangle - 90;
			//alert(clickangle);
			//alert(clickangleabs);

			var distance = Math.sqrt(Math.pow(relPoint.x , 2) + Math.pow(relPoint.y , 2));
			//alert(distance);
			//alert(chartContext.pie.donutSize);
			//alert(Math.ceil(distance/(chartContext.pie.defaultSize/(this.maxvalue*2))));

			var numsegments = this.series.length;
			var segradius = 360/numsegments;
			var segmentnumber = 0;
			for(var i=0; i<=360; i+=segradius){
				if(clickangle >= i){
					segmentnumber++;
				}
			}
			//alert(segmentnumber);

			if(segmentnumber && segmentnumber<=this.series.length){
				var newvalue = Math.ceil(distance/(chartContext.pie.defaultSize/(this.maxvalue*2)));
				if(newvalue <= this.maxvalue){
					this.series[segmentnumber-1] = Math.ceil(distance/(chartContext.pie.defaultSize/(this.maxvalue*2)));
					chartContext.updateSeries (this.series, false);
				}
			}
			/*
            console.log(config.series[config.seriesIndex])
            console.log(config.config.series[config.seriesIndex].name)
            console.log(config.config.series[config.seriesIndex].data[config.dataPointIndex])
            */
			//this.chartClicked();
			//alert(JSON.stringify(config));
		} ,
		pointToRelPoint: function(center , point) {
        	return { x: point.x - center.x, y: point.y - center.y }
    	}
	}
};
</script>
